function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6321 4.44213C10.8763 4.19794 11.2855 4.21122 11.546 4.4718C11.8066 4.73237 11.8199 5.14156 11.5757 5.38574L8.95257 8.00887L11.5758 10.6321C11.82 10.8763 11.8067 11.2854 11.5461 11.546C11.2855 11.8066 10.8763 11.8199 10.6322 11.5757L8.00896 8.95249L5.38576 11.5757C5.14157 11.8199 4.73238 11.8066 4.47181 11.546C4.21124 11.2854 4.19795 10.8763 4.44214 10.6321L7.06534 8.00887L4.44221 5.38574C4.19802 5.14156 4.21131 4.73237 4.47188 4.4718C4.73245 4.21122 5.14164 4.19794 5.38583 4.44213L8.00896 7.06525L10.6321 4.44213Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16
})));

var SvgBtnClose24 = function SvgBtnClose24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnClose24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-close-24.0add2830.svg";
export { ForwardRef as ReactComponent };